module.exports = __webpack_public_path__ + "static/media/appointment.d1dd953b.png";